import React, { createContext, useCallback, useContext, useState } from 'react';
import type { ErrorResponse } from '@apollo/client/link/error';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '@otp/ui';

export interface ErrorContextType {
  onServerError: (error: ErrorResponse) => boolean;
}

const ErrorContext = createContext<ErrorContextType>({} as ErrorContextType);

function useErrorContext() {
  return useContext(ErrorContext);
}

function ErrorProvider({ children }: { children?: React.ReactNode }) {
  const { t, i18n } = useTranslation();
  const notifications = useNotifications();

  const onServerError = useCallback((e: ErrorResponse) => {
    console.log('Error: ', e);
    const error = (e?.networkError as any)?.result?.errorCode;
    if (i18n.exists(`error.${error}`)) {
      const translatedError = t(`error.${error}`);
      notifications.show(translatedError, {
        severity: 'error',
      });

      return true;
    }

    return false;
  }, []);

  return (
    <ErrorContext.Provider value={{ onServerError }}>
      {children}
    </ErrorContext.Provider>
  );
}

export { ErrorProvider, useErrorContext };
